import React from 'react';
import { RootState } from '../../../redux/store';
import { useSelector } from 'react-redux';
import { getProjects } from '../../../redux/slices/resourcesSlices';
import { useSearchParams } from 'react-router-dom';
import { CommonResources } from '../CommonResources';

export const Projects = () => {
  const [searchParams] = useSearchParams();
  const curriculumId = searchParams.get('curriculumId') ?? '';
  const { projects } = useSelector((state: RootState) => state.resources);

  return (
    <CommonResources
      tableData={projects}
      curriculumId={curriculumId}
      getResourceAction={getProjects}
      resourceTypeLabel={'projects'}
      label="Projects"
    />
  );
};
